// action - state management
import { LOGIN, LOGOUT } from './actions';

// initial state
export const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user_id: ''
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN: {
      const { user_id } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user_id
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user_id: '',
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
